export default __webpack_public_path__ + "static/media/img5.6c663966.jpg";